export const ERROR_DIALOG_TITLE = 'error.dialog.title';
export const ERROR_DIALOG_SUBTITLE = 'error.dialog.subtitle';
export const ERROR_DIALOG_DISMISS = 'error.dialog.dismiss';
